import { getToken } from './auth';
import { getBaseUrl } from './utils';

function authHeaders() {
  const token = getToken();
  return token
    ? { Authorization: `Bearer ${token}`, Accept: 'application/json' }
    : { Accept: 'application/json' };
}

export async function getActiveAnnouncements() {
  try {
    const base = getBaseUrl();
    const res = await fetch(
      `${base}/bot/api/announcements`.replace(/([^:]\/)\/+/g, '$1'),
      { headers: authHeaders() }
    );
    if (!res.ok) return [];
    const data = await res.json().catch(() => ({}));
    return Array.isArray(data.items) ? data.items : [];
  } catch {
    return [];
  }
}
